export default function AboutSection() {
  return (
    <section className="bg-background-100 py-20 md:py-28 px-8 md:px-16">
      <div className="max-w-5xl">
        <span className="text-xs md:text-sm font-label text-secondary-500 uppercase tracking-widest mb-8 block">
          Our Approach
        </span>

        <div className="relative">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-heading text-primary-700 leading-[1.1] tracking-tight">
            Building systems
            <br />
            that last,
            <br />
            evolving with purpose
          </h2>

          <div className="hidden md:block absolute top-0 right-0 w-16 h-16 rounded-full overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20sand%20colored%20texture%2C%20minimalist%20geometric%20pattern%2C%20soft%20organic%20shapes%2C%20no%20text%2C%20macro%20photography%2C%20elegant%20abstract%20art%2C%20warm%20earthy%20tones%2C%20smooth%20gradient%20surface&width=120&height=120&seq=about-inline-01&orientation=portrait"
              alt="Warm abstract texture"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="hidden md:block absolute bottom-2 left-[-20px] w-12 h-12 rounded-full overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20cool%20blue%20and%20steel%20gray%20texture%2C%20minimalist%20geometric%20surface%2C%20soft%20metallic%20sheen%2C%20no%20text%2C%20macro%20photography%2C%20elegant%20abstract%20art%2C%20industrial%20metal%20tones%2C%20smooth%20brushed%20surface&width=120&height=120&seq=about-inline-02&orientation=portrait"
              alt="Cool metallic abstract texture"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="hidden md:block absolute bottom-2 right-24 w-20 h-4 rounded-sm overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20geometric%20slate%20gray%20mark%2C%20abstract%20rectangular%20shape%2C%20solid%20color%20block%2C%20no%20text%2C%20clean%20minimal%20design%2C%20dark%20charcoal%20tone%2C%20smooth%20matte%20surface&width=80&height=24&seq=about-inline-03&orientation=landscape"
              alt="Geometric slate mark"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="mt-14 md:mt-20 max-w-xl">
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
            We follow modern software engineering practices including clean architecture, performance optimization, and user-centered design. Every system we build is designed for maintainability and long-term evolution, ensuring that technical decisions made today remain sound well into the future.
          </p>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mt-6">
            Our team emphasizes continuous innovation and the steady improvement of development workflows. By adopting up-to-date engineering standards and actively exploring emerging technologies, we refine our internal processes to consistently deliver reliable, future-ready IT solutions.
          </p>
        </div>
      </div>
    </section>
  );
}